import { render } from "./Page3.vue?vue&type=template&id=2dd47ee4"
import script from "./Page3.vue?vue&type=script&lang=js"
export * from "./Page3.vue?vue&type=script&lang=js"

import "./Page3.vue?vue&type=style&index=0&id=2dd47ee4&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__